var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated && _vm.alerts > 0)?_c('div',{staticClass:"j-end p-t-10 p-b-10 p-r-5"},[_c('modal-alert'),_c('div',{staticClass:"route",on:{"click":_vm.to_alerts}},[_vm._v(" Alertas "),_c('b-button',{staticClass:"apretable",attrs:{"variant":"danger"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.alerts)+" ")])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }